module.exports = __webpack_public_path__ + "static/media/extractionPatient.6b3e7b08.png";